export const GENERIC: string = "Generic";
export const SPECIFIC: string = "Specific";
